import React from "react";
import { useLocation } from "react-router-dom";
import support from "../image/support.png";

export default function Help() {

  const location = useLocation();

  return (
    <>
      <div className="need-help-support">
        <a href="https://wa.me/+916390008506"  rel="noreferrer" target="_blank" className="support">
          <img src={support} alt="support" />
        </a>
        <div className="toast show">
          <div className="toast-body">
            <span className="text-dark">Need Help?</span>
            <button type="button" data-bs-dismiss="toast">
              <i className="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
        {location.pathname=== '/free-gym-listing' &&(
           <a href="tel:+916390008506" className="call-us"><i className="bi bi-telephone me-2"></i>Call Us Now</a>
        )}
       
      </div>
    </>
  );
}
